import { TChatListData, TGetChatMessage } from 'features/chat/types'
import useFetchPage2 from 'hooks/useFetchPage2'
import { FC } from 'react'
import useChatMessagePusher from 'features/chat/hooks/useChatMessagePusher'
import ChatMessageHeader from './ChatMessageHeader'
import ChatMessageBody from './ChatMessageBody'

const ChatMessageScreen: FC<{
 data?: TChatListData
}> = ({ data }) => {
 useChatMessagePusher({ leadId: data?.leadId, chatId: data?.id })

 const { flatData, fetchMore, hasMore, total, isLoading } =
  useFetchPage2<TGetChatMessage>('chat/messages', {
   customKey: `chat-messages-${data?.leadId}`,
   params: `lead_id=${data?.leadId}`,
   enable: !!data?.leadId,
  })

 //  if (!flatData || (flatData && flatData.length === 0)) {
 //   return <BaseEmptyBlock />
 //  }
 return (
  <div className="chat-messenger-item">
   <ChatMessageHeader data={data} leadId={data?.leadId} />
   <ChatMessageBody
    leadId={data?.leadId ?? ''}
    isDirectChat
    data={flatData}
    fetchMore={fetchMore}
    hasMore={hasMore}
    isLoading={isLoading}
    total={total}
   />
  </div>
 )
}

export default ChatMessageScreen
